import React from 'react'
import Tilt from 'react-tilt'
import "./Flit.css"

const Flit = () => {

  return (
    <div className='flex flex-col flex-wrap w-[230px] h-[230px] cursor-pointer relative  '>
      <div className='flex flex-col flex-wrap w-full h-full'>
        <Tilt className="Tilt  w-full h-full flip  rounded-t-2xl " options={{ max: 25 }} >
          <div className=" flex flex-row flex-wrap w-full h-full ">
            <img src={require("../../assets/images/slide.gif")} className=' w-full Tilt-inner ' alt={"slide"} />
          </div>

        </Tilt>
      </div>
    </div>
  )
}

export default Flit